module.exports = __webpack_public_path__ + "img/verifacti.831b5e75.png";